// i18n area 'system' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.ru-RU.meta.json.
import type { enUS } from './system'

export const ruRU: typeof enUS = {
  diagnostics: {
    title: 'Диагностика',
    subtitle: 'Что не так, худшее сначала — та же линза, что и tvirt diagnose',
    reload: 'Перезагрузить',
    loadError: 'Не удалось прочитать диагностику',
    exportBundle: 'Экспортировать пакет',
    exportError: 'Не удалось создать пакет',
    noProblem: 'Проблем в проверенных областях нет',
    nothingInspected: 'НИЧЕГО не проверено — это не справка о здоровье',
    inspected: 'Проверены',
    notInspected: 'НЕ проверены',
    localHint: 'Локальные области узла (юниты systemd, журнал) читаются только из CLI: tvirt diagnose --area local — путь, когда API не отвечает.',
    thresholds: 'неудачные задачи за {hours} ч, heartbeat опаздывает более чем на {seconds} с',
    severity: {
      critical: 'Критично',
      warning: 'Предупреждение',
      unknown: 'Неизвестно'
    }
  },
  explorer: {
    title: 'Проводник ресурсов',
    root: 'Корень',
    empty: 'В этом скоупе ничего нет',
    previewHint: 'Выберите объект, чтобы увидеть его предпросмотр',
    open: 'Открыть',

    // Глубокая ссылка ?scope= списков CRUD (раунд #109), из проводника (#143).
    openScoped: 'Открыть список в этом скоупе',
    kinds: {
      vm: 'ВМ',
      vmTemplate: 'Шаблон ВМ',
      ct: 'CT',
      ctTemplate: 'Шаблон CT',
      app: 'Приложение',
      overlayNetwork: 'Оверлейная сеть',
      networkService: 'Сетевая служба',
      fabric: 'Фабрика',
      subnet: 'Подсеть',
      storage: 'Пул хранилища',
      disk: 'Диск',
      catalogFile: 'Файл каталога',
      ociRegistry: 'Реестр OCI',
      ociImage: 'Образ OCI',
      cephCluster: 'Кластер Ceph',
      backupDestination: 'Цель резервного копирования',
      user: 'Пользователь',
      group: 'Группа',
      role: 'Роль',
      credential: 'Учетные данные',
      tag: 'Тег',
      proximityRule: 'Правило близости'
    }
  },
  tags: {
    title: 'Теги',
    empty: 'Тегов нет',
    add: 'Добавить тег',
    remove: 'Убрать',
    name: 'Тег',
    value: 'Значение',
    save: 'Сохранить',
    saveError: 'Не удалось сохранить теги',
    loadError: 'Не удалось загрузить словарь тегов',
    noVocabulary: 'Для этого типа ресурса нет ни одного тега',

    // Уже заданный одинарный тег отвечает 409: замена всегда явная — никогда
    // неявная подстановка (проектное решение, утверждено 2026-07-27).
    overwrite: 'Заменить текущее значение',

    // Система > Теги, поверхность словаря.
    createTitle: 'Создать тег',
    editTitle: 'Изменить тег',
    nameHint: 'Буквы, цифры, точки, дефисы и подчеркивания — без ":" и без "/"; префикс tvirt- принадлежит платформе',
    cardinality: 'Кардинальность',
    cardinalitySingle: 'Одно значение',
    cardinalityMultiple: 'Несколько значений',
    cardinalityHint: 'При одном значении повторное назначение тега потребует его замены',
    autoCreate: 'Автосоздание значений',
    autoCreateOn: 'При назначении',
    autoCreateOff: 'Только объявленные',
    autoCreateHint: 'Включено: назначение нового значения создает его. Выключено: назначаются только объявленные значения',
    values: 'Значения',
    noValues: 'Ни одного значения не объявлено',
    addValue: 'Добавить значение',
    duplicateValue: 'Значение повторяется',
    kinds: 'Типы ресурсов',
    kindsAll: 'Все',
    kindsPlaceholder: 'Все',
    kindsHint: 'Оставьте пустым, чтобы допустить любой тип ресурса, поддерживающий теги',
    systemChip: 'Система',
    deleteCascade: 'Удалить также назначения',
    deleteCascadeHint: 'Тег, всё ещё назначенный какому-либо ресурсу, отклоняется: с этой опцией значения и все назначения удаляются вместе с тегом.'
  },
  scopes: {
    title: 'Скоупы',
    createTitle: 'Создать скоуп',
    editTitle: 'Переименовать скоуп',
    path: 'Путь',
    segment: 'Сегмент',
    segmentHint: 'Строчные буквы, цифры и дефисы (DNS-1123)',
    parent: 'Родитель',
    rootChip: 'Корень',
    preview: 'Новый скоуп',
    pickLabel: 'Скоуп',
    pickHint: 'Где объект живет в дереве кластера — в корне или в одном из vDC внутри него.',
    ociCache: 'Кэш OCI (переопределение)',
    appEphemeral: 'Эфемерные пулы приложений (переопределение)',
    inherit: 'Наследовать',
    inheritsFrom: 'Наследует от',
    inheritsCluster: 'Наследует значение кластера по умолчанию',
    inheritsNone: 'Наследует — действующего пула нет',
    failoverProtection: 'Защита в деградировавшем кластере',
    networkWeight: 'Сетевой вес',
    networkCeil: 'Сетевой потолок (Мбит/с)',
    protectionProtected: 'Защищённая',
    protectionExpendable: 'Жертвуемая при деградации',
    protectionDefault: 'По умолчанию кластера'
  },

  // Система > Информация (раунд #124, 2026-07-31): версии платформы в парке
  // (не более двух в ходе обновления), компоненты каждого узла, руководство в
  // PDF, отдаваемое локально, и встроенная карточка лицензии.
  sysinfo: {
    summary: 'Версии платформы в кластере, компоненты каждого узла, руководство администратора и лицензия.',
    platformTitle: 'Платформа TVirt',
    platformSubtitle: 'Версии, наблюдаемые на узлах кластера',
    versionOnNodes: '{version} — узлов: {n}',
    versionOnOneNode: '{version} — на 1 узле',
    mixedVersions: 'В кластере больше одной версии платформы — так бывает только во время обновления (максимум две).',
    tooManyVersions: 'В кластере больше двух версий платформы — такого не бывает никогда, даже во время обновления: проверьте узлы ниже.',
    unreportedNodes: 'Еще не сообщили свои версии: {nodes}',
    noVersionsYet: 'Ни один узел еще не сообщил свои версии.',
    nodesUnavailable: 'Список узлов не виден с вашими правами — показать версии платформы невозможно.',
    colNode: 'Узел',
    manualTitle: 'Руководство администратора',
    manualSubtitle: 'Локальная копия, отдаваемая этим кластером',
    manualBody: 'Полное руководство TVirt в PDF, отдаваемое прямо платформой — доступно и в изолированных средах.',
    manualLink: 'Руководство администратора (PDF)',
    apiExplorerTitle: 'Обозреватель API',
    apiExplorerSubtitle: 'Контракт OpenAPI, доступный для просмотра',
    apiExplorerBody: 'Полный контракт OpenAPI платформы — каждый маршрут, схема и код ответа — доступен для просмотра из браузера, обслуживается через этот узел.',
    apiExplorerLink: 'Исследовать API',
    kubeTitle: 'Совместимость с Kubernetes',
    kubeSubtitle: 'kubectl и его инструменты перед нативным API',
    kubeBody: 'TVirt KubeCompat проецирует Pod-ы, Deployment-ы, Service-ы, namespace-ы, узлы и события в диалект Kubernetes — только чтение, плюс удаление Deployment-ов. Каждый вызов проходит через нативный API с твоими правами: в kubeconfig используй app token как bearer.',
    kubeEndpoint: 'Endpoint для kubectl',
    kubeStatusActive: 'Активен — Kubernetes {version}',
    kubeStatusMissing: 'Не установлен на этом узле (пакет trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Установлен, но не отвечает — проверь юнит trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Проверка…'
  },

  // Лицензирование (раунд 2026-07-29): страница подписочной лицензии.
  licensing: {
    title: 'Лицензия кластера',
    subtitle: 'Подписочная лицензия — не более одной на кластер',
    absentTitle: 'Лицензия не зарегистрирована',
    absentBody:
      'Без действительной лицензии кластер отказывается запускать новые виртуальные машины (уже запущенные ВМ продолжают работать). Зарегистрируйте ключ продукта, полученный вместе с подпиской.',
    registerButton: 'Зарегистрировать лицензию',
    removeButton: 'Убрать лицензию',
    state: {
      ok: 'Действительна',
      limitExceeded: 'Лимит превышен',
      expired: 'Истекла'
    },
    productKeyLabel: 'Ключ продукта',
    basisLabel: 'Основа лимита',
    basis: {
      concurrentVms: 'Одновременно запущенные ВМ',
      physicalCores: 'Физические ядра (всего по кластеру)'
    },
    limitLabel: 'Лимит',
    usageLabel: 'Текущее использование',
    usageOf: '{used} из {limit}',
    usagePartial: 'частичная сумма — узлов без наблюдаемой топологии CPU: {n}',
    usageUnknown: 'сейчас наблюдать невозможно',
    expiresLabel: 'Срок действия',
    neverExpires: 'никогда',
    registeredLabel: 'Зарегистрирована',
    gateNote:
      'Если лицензия отсутствует, истекла или превышен ее лимит, кластер отказывается запускать НОВЫЕ виртуальные машины. Уже запущенные ВМ продолжают работать, и на перезапуски HA это не влияет.',
    devStage:
      'Стадия разработки: ключ продукта принимается как есть вместе с объявленными здесь лимитами; проверка подписанного ключа появится в одном из будущих выпусков.',
    dialogTitle: 'Зарегистрировать лицензию',
    dialogExpiresHelp: 'Пусто = лицензия никогда не истекает',
    dialogSubmit: 'Зарегистрировать',
    dialogError: 'Не удалось зарегистрировать лицензию.',
    removeTitle: 'Убрать лицензию',
    removeBody:
      'Кластер останется БЕЗ ЛИЦЕНЗИИ: новые виртуальные машины откажутся запускаться, пока вы не зарегистрируете лицензию. Уже запущенные ВМ продолжают работать.',
    removeConfirm: 'Убрать',
    removeError: 'Не удалось убрать лицензию.'
  },
  rbac: {
    tabRoles: 'Роли',
    tabGrants: 'Назначения',
    rolesTitle: 'Роли',
    createRoleTitle: 'Создать роль',
    editRoleTitle: 'Изменить роль',
    nameHint: 'Строчные буквы, цифры и дефисы; префикс tvirt- зарезервирован',
    systemChip: 'Система',
    permissions: 'Разрешения',
    permissionsPlaceholder: 'Добавить разрешение…',
    includedRoles: 'Включенные роли',
    includedRolesPlaceholder: 'Добавить роль…',
    grantsTitle: 'Назначения',
    createGrantTitle: 'Создать назначение',
    principal: 'Субъект',
    principalKind: 'Тип субъекта',
    principalUser: 'Пользователь',
    principalGroup: 'Группа',
    role: 'Роль',
    grantRight: 'Делегирование',
    grantRightChip: 'Может делегировать',
    grantRightLabel: 'С правом делегирования (получатель может, в свою очередь, делегировать эту роль дальше)',
    effective: 'Действует',
    notEffective: 'Не действует',
    createdAt: 'Создано',
    scopeHint: '/path — точно, /path/* — рекурсивно; назначения крепятся к смонтированному корню (/* назначить нельзя)'
  },
  groups: {
    title: 'Группы',
    createTitle: 'Создать группу',
    nameHint: 'Строчные буквы, цифры и дефисы; уникально в пределах скоупа',
    members: 'Участники',
    membersTitle: 'Участники',
    membersPlaceholder: 'Добавить пользователя…',
    noMembers: 'Участников нет',
    realmMappings: 'Сопоставления с реалмами',
    realmMappingsTitle: 'Сопоставления с реалмами',
    realmMappingsHint:
      'Чему эта группа соответствует в каждом внешнем реалме. Членство читается из каталога в момент входа: группа каталога, которую здесь никто не сопоставил, игнорируется, а вложенность не разворачивается — уплощайте ее на стороне каталога.',
    realm: 'Реалм',
    externalGroup: 'Внешняя группа',
    addRealmMapping: 'Добавить сопоставление',
    removeRealmMapping: 'Убрать сопоставление',
    noRealmMappings: 'Сопоставлений с реалмами нет',

    // Диалог создания по разделам (раунд realm-wizard, 2026-08-03): «Общее»
    // плюс поверхность сопоставления с внешними реалмами и говорящее пустое
    // состояние.
    sectionGeneral: 'Общее',
    mappingsNoRealms: 'Внешние реалмы не настроены — поверхность сопоставления откроется, как только появится хотя бы один реалм.',
    mappingsNoRealmsLink: 'Открыть вкладку «Реалмы и SSO»',

    // Требование MFA, налагаемое группой (раунд #178, половина B): чистое OR —
    // группа может требование только ДОБАВИТЬ, никогда его не снять.
    mfaRequired: 'Требование MFA',
    mfaRequiredChip: 'Требует MFA',
    mfaNotRequiredChip: 'Без требования',
    mfaRequiredHint:
      'Чистое OR: группа может ДОБАВИТЬ требование второго фактора своим участникам — в том числе внешним идентичностям, через сопоставления с реалмами, — но никогда его не снять. Действует со следующего входа: открытые сеансы не закрываются.'
  },
  users: {
    title: 'Пользователи',
    createTitle: 'Создать пользователя',
    editTitle: 'Изменить пользователя',
    username: 'Имя пользователя',
    usernameHint: 'Строчные буквы, цифры, точки и дефисы',
    displayName: 'Отображаемое имя',
    enabled: 'Включен',
    state: 'Состояние',
    enabledChip: 'Включен',
    disabledChip: 'Отключен',
    lockedChip: 'Заблокирован',
    password: 'Пароль',
    passwordSetChip: 'Задан',
    mustChangeChip: 'Требует смены',
    initialPassword: 'Начальный пароль',
    initialPasswordHint: 'Пользователю придется сменить его при первом входе',
    lastLogin: 'Последний вход',
    neverLoggedIn: 'Ни разу не входил',
    setPasswordTitle: 'Задать пароль',
    setPasswordHint: 'Административная замена — требует вашего пароля (режим sudo) и обязывает пользователя сменить пароль при следующем входе.',
    operatorPassword: 'Ваш пароль',
    unlock: 'Разблокировать учетную запись',
    revokeTitle: 'Отозвать сеансы',
    revokeBody: 'Все активные сеансы этого пользователя немедленно завершаются.',
    revokeIncludeTokens: 'Отозвать также токены приложений',
    revokeConfirm: 'Отозвать',

    // Стандартный диалог (раунд #156): полные детали, вкладки учетной записи и безопасности.
    tabAccount: 'Учетная запись',
    tabSecurity: 'Безопасность',
    usernameImmutableHint: 'Имя пользователя — это идентичность учетной записи, оно фиксируется при создании',
    groups: 'Группы',
    noGroups: 'Групп нет',
    mustChangePassword: 'Обязательная смена пароля',
    failedAttempts: 'Неудачные попытки входа',
    lockedUntil: 'Заблокирован до',

    // Вкладки идентичностей (2026-08-03): «Система > Пользователи» стала
    // разделом с вкладками по образцу /system/rbac — пользователи, группы,
    // внешние реалмы.
    tabUsers: 'Пользователи',
    tabGroups: 'Группы',
    tabRealms: 'Реалмы и SSO',
    tabMfa: 'MFA',

    // Вкладка MFA (задача #178, половина A — интерфейс поверх существующего
    // контракта): вид второго фактора по пользователям. Настройка внешних
    // идентичностей и осиротевшее состояние — это половина B: раунд контракта,
    // никогда форма без бэкенда.
    mfa: {
      title: 'Второй фактор (MFA)',
      methodsTitle: 'Доступные методы',
      methodsSubtitle: 'То, что эта установка умеет проверять как второй фактор',
      methodsError: 'Не удалось загрузить реестр методов',
      builtinChip: 'Встроенный',
      enrollableChip: 'Настраивается в TVirt',
      delegatedChip: 'Управляется извне',
      state: 'Состояние',
      stateActive: 'Активен',
      statePending: 'Ожидает настройки',
      stateNone: 'Не настроен',
      required: 'Требование MFA',
      requiredChip: 'Обязателен',
      notRequiredChip: 'Не обязателен',
      enrolledAt: 'Дата настройки',
      enrolledMethods: 'Настроенные методы',
      noMethods: 'Ничего не настроено',
      codesRemaining: 'Осталось кодов восстановления',
      resetTitle: 'Сбросить второй фактор',
      resetHint:
        'Настройка и все коды восстановления обнуляются: при следующем входе пользователь настроит второй фактор заново. Требование MFA остается как есть — администратор никогда не задает секрет, он только его обнуляет.',
      resetConfirm: 'Сбросить',
      resetError: 'Не удалось сбросить второй фактор',
      empty: 'Управляемых пользователей пока нет — учетные записи появятся здесь, как только возникнут, каждая со своим состоянием второго фактора.',

      // Половина B (раунд #178): происхождение действующего вердикта, внешние
      // настройки с состоянием сироты, группы, налагающие требование.
      viaSelf: 'Личное',
      viaSelfHint: 'Личный вклад учетной записи (ее флажок) — единственная часть, которую правит карандаш.',
      viaGroupHint: 'Требование, унаследованное от этой группы: снятие личного флажка не освобождает пользователя — действовать нужно на группе, во вкладке «Группы».',
      subject: 'Идентичность',
      lastSeenAt: 'Последнее подтверждение',
      enrollmentPending: 'Ожидает',
      orphanChip: 'Осиротевшая',
      orphanDirectoryMiss: 'Идентичности больше нет в каталоге',
      orphanRealmRemoved: 'Реалм удален из TVirt',
      orphanedAt: 'Осиротела с',
      directoryUuid: 'UUID в каталоге',
      externalTitle: 'Внешние настройки MFA',
      externalEmpty: 'Внешних настроек пока нет — настройка рождается при первом входе идентичности каталога, на которую распространяется требование MFA.',
      orphanHelp:
        'Осиротевшая настройка никогда не удаляется сама: это материал безопасности — она остается для аудита, и если идентичность снова появится в каталоге, она вновь обретет свой фактор. Единственный выход — административный сброс.',
      visibilityHint: 'Внешние настройки живут в корне кластера: их видит только тот, у кого есть user.read на все дерево.',
      orphanResetHint:
        'Осиротевшая строка удаляется окончательно: на нее больше никто не претендует. Если идентичность вернется в каталог, она настроит второй фактор заново.',
      enforcingTitle: 'Группы, требующие MFA',
      enforcingSubtitle:
        'Якорь требования для внешних идентичностей — группа: ее сопоставления с реалмами говорят, какой популяции каталога оно достигает. Внешняя настройка рождается при первом входе обязанного пользователя.',
      enforcingEmpty: 'Ни одна группа не требует MFA — требование включается на группе, во вкладке «Группы».',
      enforcingError: 'Не удалось загрузить группы, требующие MFA'
    }
  },
  realms: {
    title: 'Реалмы аутентификации',
    createTitle: 'Создать реалм',
    editTitle: 'Изменить реалм',
    name: 'Реалм',
    nameHint: 'Домен, который пользователи пишут после @ (example.com) — неизменяем после создания',
    nameImmutableHint: 'Имя реалма отпечатано в каждом сеансе и в каждой строке аудита, где оно когда-либо упоминалось, — переименование переписало бы историю',
    kind: 'Тип',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC и SAML придут в следующих раундах — сегодня реалм это каталог LDAPv3',

    // Полумастер создания (раунд realm-wizard, 2026-08-03): карточки типов
    // из шага 1 — ldap живой, oidc/saml в дорожной карте (никогда форма
    // без бэкенда за ней).
    kindCategory: 'Тип реалма',
    kindSelectHint: 'Выберите тип каталога, в котором этот реалм будет выполнять аутентификацию.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Имя пользователя и пароль проверяются через bind к каталогу LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Единый вход из браузера, делегированный поставщику удостоверений OpenID Connect — придет в следующих раундах.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Корпоративный единый вход с утверждениями SAML 2.0 — придет в следующих раундах.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Включен',
    urls: 'Серверы каталога',
    urlsHint: 'По одному URL ldap:// или ldaps:// в строке (1–8), пробуются по порядку — отказоустойчивость, а не балансировка',
    startTls: 'StartTLS',
    verifyCertificate: 'Проверять сертификат',
    cleartextWarning: 'Без ldaps:// или StartTLS пароль bind идет по сети открытым текстом — допустимо в лаборатории, никогда в продуктивной среде.',
    noVerifyWarning: 'Непроверенный сеанс TLS не аутентифицирует никого: отключайте проверку только для каталога, который вы не в силах починить.',
    caCertificate: 'Сертификат CA (PEM)',
    caCertificateHint: 'Необязательный набор CA, закрепленный для рукопожатия TLS/StartTLS этого реалма; пустое поле его снимает',
    caCertificatePinned: 'Закреплен',
    connectTimeout: 'Таймаут (секунды)',
    connectTimeoutHint: 'Предел на подключение и запрос для каждого URL (1–60); по его истечении пробуется следующий URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Служебная учетная запись, которая выполняет поиск пользователя; пусто = анонимный search bind (AD его отклоняет)',
    anonymousBind: 'Анонимный search bind',
    bindCredential: 'Пароль bind (хранилище ключей)',
    bindCredentialHint: 'Запись хранилища ключей вида usernamePassword с паролем bind — секрет никогда не живет в самом реалме',
    bindCredentialNone: 'Нет (анонимный bind)',
    bindCredentialEmpty: 'В хранилище ключей нет ни одной записи usernamePassword — создайте ее в разделе «Система > Учетные данные» для пароля bind.',
    baseDn: 'Base DN',
    baseDnHint: 'Поддерево, с которого начинается поиск пользователя (DC=example,DC=com)',
    userFilter: 'Фильтр пользователя',
    userFilterHint: '%u подставляется локальной частью логина с экранированием по RFC 4515; каталогам, отличным от AD, обычно нужен (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Атрибут memberOf',
    memberOfAttributeHint: 'Читается один-единственный раз, при входе — несопоставленные группы игнорируются, вложенность не разворачивается',
    uuidAttribute: 'Атрибут UUID',
    uuidAttributeHint: 'Неизменяемый UUID внутри реалма (objectGUID в AD, entryUUID в OpenLDAP) — печатается в аудите рядом с пользователь@реалм',
    displayNameAttribute: 'Атрибут отображаемого имени',
    displayNameAttributeHint: 'Используется, чтобы поприветствовать пользователя; если его нет, берется имя входа',
    sudoHint: 'Запись в реалмы защищена режимом sudo: реалм — это входная дверь в платформу',
    deleteBody: 'Сопоставления групп реалма уходят вместе с ним; аутентифицированные им сеансы живут до истечения срока — удаленный реалм просто больше никого не впускает.',
    tabConnection: 'Подключение',
    tabDirectory: 'Каталог',
    testTitle: 'Проверить подключение',
    testHint: 'Это зонд конфигурации, а не аутентификация: он подключается, выполняет bind служебной учетной записью и — если задано имя пользователя — прогоняет фильтр пользователя.',
    testUsername: 'Имя пользователя (необязательно)',
    testUsernameHint: 'Локальная часть, на которой прогоняется фильтр пользователя — здоровый ответ это 1 совпадение',
    testRun: 'Запустить проверку',
    testError: 'Не удалось выполнить зонд',
    testReachable: 'Каталог доступен, служебный bind принят',
    testUnreachable: 'Каталог НЕдоступен',
    matchedOne: 'Фильтр пользователя нашел ровно 1 запись — здоровый ответ.',
    matchedNone: 'Фильтр пользователя не нашел ни одной записи: неверен либо сам фильтр, либо base DN.',
    matchedMany: 'Фильтр пользователя нашел записей: {count} — он неизбирателен, и входы получались бы неоднозначными (их отклоняют).',
    mappingsPointer: 'Чему соответствует внешняя группа — это свойство группы TVirt (ее сопоставлений с реалмами): точка истины живет во вкладке «Группы».',
    mappingsPointerLink: 'Открыть вкладку «Группы»',
    rootHomeHint: 'Идентичности внешнего реалма живут в корне кластера, никогда в vDC: права выдаются там, где нужно, назначениями — на группу или прямо на пользователя, ровно так же, как для своих.'
  },
  credentials: {
    title: 'Учетные данные',
    createTitle: 'Создать учетные данные',
    editTitle: 'Изменить учетные данные',
    kind: 'Тип',
    kindUsernamePassword: 'Имя пользователя и пароль',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (идентичность Ceph)',
    kindHintUsernamePassword: 'Неизменяемо. Для хранилищ CIFS/SMB — учетная запись монтирования, чей секрет воркер применяет в момент монтирования.',
    kindHintIscsiChap: 'Неизменяемо. Для аутентификации CHAP в iSCSI — имя пользователя = имя CHAP, секрет = секрет CHAP.',
    kindHintNvmeDhchap: 'Неизменяемо. Для DH-HMAC-CHAP в NVMe over Fabrics — секрет = блоб DHHC-1:xx:…; имя пользователя здесь всего лишь метка.',
    kindHintCephx: 'Неизменяемо. Для клиентов Ceph — имя пользователя = имя клиента (client.…), секрет = ключ в base64.',
    kindImmutableHint: 'Тип неизменяем после создания — сменить его значит завести новые учетные данные.',
    username: 'Имя пользователя',
    usernameChap: 'Имя CHAP',
    usernameNvme: 'Метка',
    usernameCephx: 'Имя клиента',
    usernameHint: 'Необязательная учетная запись, которой принадлежит секрет',
    usernameHintChap: 'Имя CHAP, под которым аутентифицируется инициатор',
    usernameHintNvme: 'Транспортом не используется — свободная метка для ваших заметок',
    usernameHintCephx: 'Имя клиента cephx — префикс client. допускается',
    secret: 'Секрет',
    secretHint: 'Только на запись: используется потребителями, больше никогда не показывается.',
    secretHintNvmeDhchap: 'Только на запись: секрет хоста DH-HMAC-CHAP в канонической форме DHHC-1:xx:… — используется потребителями, больше никогда не показывается.',
    secretHintCephx: 'Только на запись: ключ cephx в base64 — используется потребителями, больше никогда не показывается.',
    secretEditHint: 'Оставьте пустым, чтобы не менять секрет — заполнение поля его ротирует.',
    createdAt: 'Создано',
    inUseError: '«{name}» упоминается в конфигурации одного из хранилищ — сначала отвяжите его там.',
    nameHint: 'Строчные буквы, цифры и дефисы (DNS-1123); уникально в пределах скоупа',

    // Диалог одной лишь ротации (раунд #156): у секрета никогда не бывает
    // карандаша прямо в строке.
    rotateTitle: 'Ротация секрета',
    rotateHint: 'Только на запись: новый секрет заменяет сохраненный — потребители возьмут его при следующем монтировании.',

    // Раунд #159 (PKI): вкладки «Сертификаты» и «Удостоверяющие центры».
    tabSecrets: 'Секреты',
    tabCertificates: 'Сертификаты',
    tabAuthorities: 'Удостоверяющие центры',
    certificatesTitle: 'Сертификаты',
    authoritiesTitle: 'Удостоверяющие центры',
    caCreateTitle: 'Новый CA',
    certCreateTitle: 'Новый сертификат',
    caMode: 'Источник',
    caModeGenerate: 'Сгенерировать средствами TVirt',
    caModeImport: 'Импортировать (ключ + сертификат)',
    certMode: 'Источник',
    certModeIssue: 'Выпустить из CA в хранилище ключей',
    certModeImport: 'Импортировать (ключ + сертификат)',
    issuingCa: 'Выпускающий CA',
    issuingCaHint: 'Сертификат рождается в скоупе своего CA, с зарегистрированным родителем',
    noCasHint: 'В хранилище ключей нет ни одного CA — сначала сгенерируйте или импортируйте его на вкладке CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Субъект CA: буквы, цифры, пробел, точка, подчеркивание, дефис',
    commonNameCertHint: 'OpenVPN опознает клиентов по CN — держите его уникальным в пределах CA',
    days: 'Срок действия (дни)',
    daysCaHint: '1–7300 дней; по умолчанию 3650 (10 лет)',
    daysCertHint: '1–3650 дней; по умолчанию 365',
    keyType: 'Тип ключа',
    keyTypeHint: 'По умолчанию EC P-256; RSA — для устаревших потребителей',
    usage: 'Назначение',
    usageClient: 'Клиент (clientAuth)',
    usageServer: 'Сервер (serverAuth)',
    usageHint: 'Расширенное назначение ключа, под которое выпускается сертификат',
    san: 'Альтернативные имена (SAN)',
    sanHint: 'Через запятую; литеральные IP становятся записями IP:, все остальное — DNS:',
    keyPem: 'Закрытый ключ (PEM)',
    keyPemHint: 'Только на запись: хранится в хранилище ключей, больше никогда не показывается',
    certPem: 'Сертификат (PEM)',
    certPemHint: 'Открытый сертификат, который образует пару с ключом',
    certPemCaHint: 'Сертификат CA, который образует пару с ключом (basicConstraints CA)',
    subject: 'Субъект',
    issuer: 'Издатель',
    parentCa: 'Выпускающий CA',
    parentCaImported: 'Импортирован — выпущен вне TVirt',
    serial: 'Серийный номер',
    fingerprint: 'Отпечаток (SHA-256)',
    validFrom: 'Действителен с',
    validUntil: 'Действителен до',
    expiry: 'Срок действия',
    expired: 'Истек',
    expiresInDays: 'Истекает через {days} дн.',
    revoked: 'Отозван',
    revokedAtLabel: 'Дата отзыва',
    revokeTitle: 'Отозвать сертификат',
    revokeAction: 'Отозвать',
    revokeWarning: 'Отзыв окончателен: серийный номер попадает в CRL выпускающего CA, и каждый потребитель, отвергающий отозванные сертификаты (в первую очередь OpenVPN), отвергнет и этот. Обратного действия не существует.',
    exportPem: 'Экспортировать PEM',
    exportChain: 'Экспортировать цепочку',
    exportCrl: 'Экспортировать CRL',
    materialImmutableHint: 'Материал X.509 неизменяем — перевыпустите или импортируйте заново',
    caInUseError: 'У «{name}» еще есть живые выпущенные сертификаты (или на него ссылается хранилище) — сначала отзовите или удалите их.'
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Размещение, доступность и сродство — где работают ВМ кластера и должны ли они быть запущены',
    loadError: 'Панели Proximity нужно хранилище конфигурации кластера — состояние парка сейчас недостижимо',
    config: {
      title: 'Конфигурация',
      subtitle: 'Политика размещения на уровне кластера',
      save: 'Сохранить',
      saveError: 'Конфигурация отклонена',
      strategy: 'Стратегия выбора',
      strategy_leastUsedResources: 'Меньше всего занятых ресурсов',
      strategy_leastVms: 'Меньше всего ВМ',
      strategy_random: 'Случайно',
      strategyLeastUsedResourcesHint: 'Среди годных кандидатов — узел с наибольшим остатком доступной RAM (наблюдаемый итог − резерв хоста − запущенные ВМ), а при равенстве решают обязательства по vCPU. При одних и тех же данных детерминирована.',
      strategyLeastVmsHint: 'Среди годных кандидатов — узел с наименьшим числом запущенных ВМ; равенство разрешается по имени. При одних и тех же данных детерминирована.',
      strategyRandomHint: 'Равномерно случайно среди годных кандидатов.',
      liveness: 'Порог живости узлов (секунды)',
      livenessHint: 'Член, молчащий дольше порога, считается недостижимым: он исключается из размещения и — если он не на обслуживании — считается мертвым для решателя HA, который его изолирует и перезапускает его HA-ВМ в другом месте.',
      decider: 'Решатель HA',
      deciderNone: 'еще не избран'
    },
    nodesTitle: 'Узлы',
    nodesSubtitle: 'Живость и эмпирическая емкость — доступная RAM = итог − база − занятая',
    nodeCol: 'Узел',
    stateCol: 'Состояние',
    ramCol: 'RAM (итог − база − занятая)',
    usableCol: 'Доступно',
    vmsCol: 'Нагрузка',
    neverSeen: 'ни разу не виден',
    freshChip: 'достижим',
    staleChip: 'недостижим',
    attestedChip: 'выключение подтверждено',
    ramFormula: 'итог − база − занятая',
    haTitle: 'Высокая доступность',
    haSubtitle: 'ВМ с флагом HA «всегда включены»: TVirt перезапускает их после каждой незапрошенной остановки — на том же узле с выдержкой, на другом узле, когда их узел умирает (только общее хранилище).',
    haNone: 'Ни у одной ВМ еще нет флага HA — включите его здесь или в деталях ВМ.',
    haVmCol: 'Виртуальная машина',
    haStateCol: 'Состояние',
    haRestartsCol: 'Перезапуски HA',
    haLastEventCol: 'Последнее событие',
    haToggleCol: 'HA',
    haCrashLoop: 'цикл падений',
    haToggleError: 'Изменение HA отклонено',
    rules: {
      title: 'Правила сродства',
      createTitle: 'Новое правило близости',
      editTitle: 'Изменить правило',
      nameHint: 'Строчные буквы, цифры и дефисы (метка DNS)',
      vms: 'Виртуальные машины',
      vmsHint: 'Не менее двух ВМ — правило связывает, где они работают друг относительно друга',
      type: 'Тип',
      affinity: 'Сродство (вместе)',
      antiAffinity: 'Антисродство (порознь)',
      typeAffinityHint: 'ВМ должны работать на ОДНОМ И ТОМ ЖЕ узле.',
      typeAntiAffinityHint: 'ВМ должны работать на РАЗНЫХ узлах — классическая пара HA.',
      mode: 'Режим',
      hard: 'жесткий',
      soft: 'мягкий',
      modeHardHint: 'Нарушения отклоняют операцию (запуск, миграцию, аварийное переключение) с внятной ошибкой.',
      modeSoftHint: 'Предпочтение, никогда не блокирующее: размещение с нарушением проходит, но с заметным предупреждением.',
      satisfied: 'Размещение',
      satisfiedYes: 'соблюдено',
      satisfiedNo: 'нарушено',

      // Стандартный диалог (раунд #156): у нарушений своя строка, а не подсказка.
      violations: 'Нарушения',
      noViolations: 'Нет'
    },
    events: {
      title: 'События HA',
      subtitle: 'Журнал доступности — перезапуски, изоляция узлов, аварийные переключения и честные пропуски',
      none: 'Пока ничего.',
      when: 'Когда',
      kind: 'Событие',
      target: 'Объект',
      detail: 'Подробности',
      kindRestarted: 'перезапуск HA',
      kindGaveUp: 'отказ (цикл падений)',
      kindNodeAttested: 'узел изолирован',
      kindFailedOver: 'аварийное переключение',
      kindNoCandidate: 'нет кандидата',
      kindStorageLocalSkip: 'пропущена (локальное хранилище)',
      kindZombieFenced: 'зомби уничтожен'
    }
  }
}
